// extracted by mini-css-extract-plugin
export var root = "wrapRootElement-module--root--ac2b5";